import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import './Image.css';

export const Image = ({
  src,
  alt = '',
  width = 'auto',
  height = 'auto',
  borderRadius = '0px',
  border = 'none',
  borderColor = 'transparent',
  borderStyle = 'solid',
  objectFit='contain',
  backgroundColor = 'transparent',
  placeholderImage,
  cursor,
  className = '',
}) => {
  return html`
    <img
      src=${src}
      alt=${alt}
      @error=${(e) => {
        if (placeholderImage) {
          e.target.src = placeholderImage;
        }
      }}
      style=${styleMap({
        width,
        height,
        borderRadius,
        border: `${borderStyle} ${border} ${borderColor}`,
        objectFit,
        cursor,
        backgroundColor
      })}
      class="storybook-image ${className}"
    />
  `;
};
